import type AreaAnalysis from "../AreaAnalysis"
import type Area from "../Area"
import type AnalysisBuilder from "./AnalysisBuilder"

/**
 * Runs a sequence of analysis builders and joins their output with spaces.
 */
export class AnalysisBuilderChain implements AnalysisBuilder {
	private builders: AnalysisBuilder[]

	constructor(builders: AnalysisBuilder[]) {
		this.builders = builders
	}

	build(analysis: AreaAnalysis, area: Area): string {
		const parts = this.builders
			.map((builder) => builder.build(analysis, area))
			.filter((s) => s.trim().length > 0)
		return parts.join(" ")
	}
}
